module.exports = __webpack_public_path__ + "img/header.e89cc534.svg";